import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { useTranslation } from "react-i18next";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import {
  getComboTemplates,
  insertTemplate,
} from "Stores/actions/properties/ShopAction";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";

export default function NewTemplate({ row, onEnter, onChangeList }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);

  const [controls, setControls] = useSetState({
    Template: {
      type: "select",
      selectItems: [],
      value: null,
    },
    description: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
  });

  useEffect(() => {
    if (onEnter) {
      onClear();
    }
  }, [onEnter]);

  const onClear = async () => {
    setCheckValid(false);
    setFormValid({ description: false });
    setControls({ description: { value: "" } });
    await get_ComboTemplates(+row.Id);
  };

  const get_ComboTemplates = async (idGroup) => {
    setLoading(true);
    const data = await dispatch(
      getComboTemplates({
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        idGroup,
      })
    );
    setControls({ Template: { selectItems: data } });
    setControls({ Template: { value: data[0] } });
    setLoading(false);
  };

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    if (name !== "nameSearch")
      setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { Template, description } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true) &&
      Template.value
    ) {
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          idGroup: +row.Id,
          idTemplate: Template.value.Id,
          description: description.value,
        };
        setLoading(true);
        onChangeList(await dispatch(insertTemplate(data)));
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <Grid container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid item key={key + index} xs={12} sm={4}>
            {controls[key].type === "select" && (
              <MuiAutoComplete
                options={controls[key].selectItems}
                label={<Translator id={key} />}
                value={controls[key].value}
                id={key}
                onChange={autoCompleteHandler}
              />
            )}
            {controls[key].type === "text" && (
              <Input
                setValue={setValue.bind(this)}
                value={controls[key].value}
                name={key}
                validation={controls[key].validation}
                label={<Translator id={key} />}
                type="text"
                checkValid={checkValid && !formValid[key]}
              />
            )}
          </Grid>
        );
      })}
      <Grid item xs={12} sm={4} className="d-flex flex-row  align-items-center">
        <MuiButton
          loading={loading}
          color="primary"
          title={<Translator id="ezafe_be_list" />}
          onClick={onFinish}
          fullwidthOnSm
        />
      </Grid>
    </Grid>
  );
}
